// Удалили объект (рисунок, таблицу, формулу, листинг, приложение, раздел), на который есть перекрёстные ссылки:
// сразу предупреждаем - ссылки стали «??», Ctrl+Z вернёт объект (иначе студент заметит это только в PDF).
import { Extension } from '@tiptap/core';
import { NodeSelection, Plugin, PluginKey } from '@tiptap/pm/state';
import type { Node as PMNode } from '@tiptap/pm/model';
import { ctx } from '../../core/ctx';

const KIND: Record<string, string> = {
  figure: 'рисунок', stoTable: 'таблицу', formula: 'формулу', listing: 'листинг', appendix: 'приложение', heading: 'раздел',
};

function objects(doc: PMNode): Map<string, string> {
  const m = new Map<string, string>();
  doc.descendants((n) => {
    if (KIND[n.type.name] && n.attrs.id) m.set(n.attrs.id, n.type.name);
    return n.type.name === 'appendix' || n.type.name === 'doc';
  });
  return m;
}

export const DeleteGuardExtension = Extension.create({
  name: 'stoDeleteGuard',
  addProseMirrorPlugins() {
    return [new Plugin({
      key: new PluginKey('stoDeleteGuard'),
      view: () => ({
        update: (view, prev) => {
          const st = view.state;
          if (st.doc === prev.doc || st.doc.content.size >= prev.doc.content.size) return;
          // только удаление выделенного (объект выделен щелчком или вместе с текстом), не набор и не отмена
          if (prev.selection.empty && !(prev.selection instanceof NodeSelection)) return;
          const before = objects(prev.doc);
          const after = objects(st.doc);
          const gone = [...before.keys()].filter((id) => !after.has(id));
          if (!gone.length) return;
          const set = new Set(gone);
          let refs = 0;
          const kinds = new Set<string>();
          st.doc.descendants((n) => {
            if (n.type.name === 'xref' && set.has(n.attrs.target)) { refs++; kinds.add(before.get(n.attrs.target)!); }
            return true;
          });
          if (!refs) return;
          const what = [...kinds].map((k) => KIND[k]).join(', ');
          ctx.toast(`Удалён объект (${what}), на который в тексте есть ссылки: ${refs} - они показаны как «??». Ctrl+Z - вернуть объект`, 'warn', 9000);
        },
      }),
    })];
  },
});
